import React, { useState } from 'react';
import styled from 'styled-components';
import mm05 from '../assets/0-5mm.jpg';
import mm1 from '../assets/1mm.jpg';
import mm16 from '../assets/1-6mm.jpg';
import mm3 from '../assets/3mm.jpg';
import bigbag from '../assets/bigbag.jpg';
import sac from '../assets/sac.jpg';

// Styled components
const ProductsContainer = styled.div`
  padding: 20px;
  text-align: center;
`;

const Section = styled.section`
  padding: 40px 20px;
  margin: 20px 0;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 20px;
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const ProductCard = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
  margin-bottom: 15px;
`;

const ProductTitle = styled.h3`
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 10px;
`;

const ProductDescription = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 15px;
`;

const QuantityInput = styled.input`
  width: 60px;
  padding: 5px;
  font-size: 1rem;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 15px;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: border-color 0.3s ease;
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  width: 100%;

  &:focus {
    border-color: #2089ac;
    outline: none;
  }
`;

const Info = styled.div`
  padding: 40px 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`;

const DeliveryOptionButton = styled.button`
  background-color: ${({ selected }) => (selected ? '#2089ac' : '#f9f9f9')};
  color: ${({ selected }) => (selected ? 'white' : '#2c3e50')};
  padding: 10px 20px;
  font-size: 1rem;
  border: 1px solid #2089ac;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #2089ac;
    color: white;
  }
`;

const CartSection = styled.div`
  margin-top: 40px;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CartTitle = styled.h3`
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 20px;
`;

const CartItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
`;

const CartItemName = styled.span`
  font-size: 1rem;
  color: #555;
`;

const CartItemQuantity = styled.span`
  font-size: 1rem;
  color: #555;
`;

const SendOrderButton = styled.button`
  background-color: #25d366;
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 20px;

  &:hover {
    background-color: #128c7e;
  }
`;

const GSendOrderButton = styled.button`
  background-color: #D84040;
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 20px;

  &:hover {
    background-color: #A31D1D;
  }
`;

const Products = () => {
  const products = [
    { id: 1, name: 'Sable de silice 0,5mm', description: 'Idéal pour la filtration et les applications industrielles.', image: mm05 },
    { id: 2, name: 'Sable de silice 1mm', description: 'Parfait pour la construction et les revêtements.', image: mm1 },
    { id: 3, name: 'Sable de silice 1,6mm', description: 'Utilisé pour le sablage et les terrains de sport.', image: mm16 },
    { id: 4, name: 'Sable de silice 3mm', description: 'Adapté pour les applications industrielles et la fonderie.', image: mm3 },
  ];

  const deliveryOptions = [
    { id: 1, name: 'Big Bag', description: 'Livraison en big bag pour les grandes quantités.', image: bigbag },
    { id: 2, name: 'Sac', description: 'Livraison en sacs pour une utilisation pratique.', image: sac },
  ];

  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [cart, setCart] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [intendedUse, setIntendedUse] = useState('');
  const [deliveryDestination, setDeliveryDestination] = useState('');

  const addToCart = (product, quantity) => {
    const existingProduct = cart.find((item) => item.id === product.id);
    if (existingProduct) {
      setCart(cart.map((item) => (item.id === product.id ? { ...item, quantity: item.quantity + quantity } : item)));
    } else {
      setCart([...cart, { ...product, quantity }]);
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter((item) => item.id !== productId));
  };

  const sendOrderViaWhatsApp = () => {
    if (!selectedDelivery || cart.length === 0) {
      alert('Veuillez sélectionner une méthode de livraison et ajouter des produits au panier.');
      return;
    }

    const phoneNumber = '+212661497628';

    // Generate the list of products in the cart
    const productList = cart
      .map((item) => `${item.name}: ${item.quantity} tonne(s)`)
      .join('\n');

    // Create the WhatsApp message
    const message = encodeURIComponent(
      `Bonjour,\nMerci de bien vouloir me transmettre un devis correspondant aux critères suivants :\n\n` +
      `- Le nom de votre société et votre activité:\n${companyName}\n\n` +
      `- L'utilisation prévue du sable:\n${intendedUse}\n\n` +
      `- Les produits recherchés:\n${productList}\n\n` +
      `- La quantité souhaitée:\n${cart.reduce((total, item) => total + item.quantity, 0)} tonne(s)\n\n` +
      `- Le mode de transport:\n${selectedDelivery.name}\n\n` +
      `- La destination de la livraison:\n${deliveryDestination}`
    );

    // Open WhatsApp with the pre-filled message
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');

  };
  const sendOrderViaGmail = () => {
	if (!selectedDelivery || cart.length === 0) {
	  alert('Veuillez sélectionner une méthode de livraison et ajouter des produits au panier.');
	  return;
	}
  
	const productList = cart
	  .map((item) => `${item.name}: ${item.quantity} tonne(s)`)
	  .join('\n');
  
	// Create the email body
	const body = `Bonjour,\nMerci de bien vouloir me transmettre un devis correspondant aux critères suivants :\n\n` +
	  `- Le nom de votre société et votre activité:\n${companyName}\n\n` +
	  `- L'utilisation prévue du sable:\n${intendedUse}\n\n` +
	  `- Les produits recherchés:\n${productList}\n\n` +
	  `- La quantité souhaitée:\n${cart.reduce((total, item) => total + item.quantity, 0)} tonne(s)\n\n` +
	  `- Le mode de transport:\n${selectedDelivery.name}\n\n` +
	  `- La destination de la livraison:\n${deliveryDestination}`;

	const email = 'anejjarider@gmail.com';
	const subject = encodeURIComponent('Demande de Devis');
	const encodedBody = encodeURIComponent(body);
  
	window.open(`mailto:${email}?subject=${subject}&body=${encodedBody}`, '_blank');
  };

  return (
    <ProductsContainer>
      <h2>Nos Produits</h2>
      <p>Découvrez notre gamme de sable siliceux de haute qualité.</p>

      <Section>
        <SectionTitle>Types de Sable Siliceux</SectionTitle>
        <ProductGrid>
          {products.map((product) => {
            const cartItem = cart.find((item) => item.id === product.id);
            const quantity = cartItem ? cartItem.quantity : 1;

            return (
              <ProductCard key={product.id}>
                <ProductImage src={product.image} alt={product.name} />
                <ProductTitle>{product.name}</ProductTitle>
                <ProductDescription>{product.description}</ProductDescription>
               <QuantityInput
				type="number"
				min="1"
				value={quantity}
				onChange={(e) => {
					const newValue = e.target.value;
					if (newValue === "") {
					addToCart(product, 0); // Handle empty case gracefully
					} else {
					addToCart(product, parseInt(newValue, 10) - quantity);
					}
				}}
				/>

                <DeliveryOptionButton
                  onClick={() => addToCart(product, quantity)}
                  selected={cart.some((item) => item.id === product.id)}
                >
                  {cartItem ? 'Mettre à jour' : 'Ajouter au panier'}
                </DeliveryOptionButton>
              </ProductCard>
            );
          })}
        </ProductGrid>
      </Section>

      <Section>
        <SectionTitle>Options de Livraison</SectionTitle>
        <ProductGrid>
          {deliveryOptions.map((option) => (
            <ProductCard key={option.id}>
              <ProductImage src={option.image} alt={option.name} />
              <ProductTitle>{option.name}</ProductTitle>
              <ProductDescription>{option.description}</ProductDescription>
              <DeliveryOptionButton
                onClick={() => setSelectedDelivery(option)}
                selected={selectedDelivery?.id === option.id}
              >
                Sélectionner
              </DeliveryOptionButton>
            </ProductCard>
          ))}
        </ProductGrid>
      </Section>

      <CartSection>
        <CartTitle>Votre Commande</CartTitle>
        {cart.map((item) => (
          <CartItem key={item.id}>
            <CartItemName>{item.name}</CartItemName>
            <CartItemQuantity>{item.quantity} tonne(s)</CartItemQuantity>
            <DeliveryOptionButton onClick={() => removeFromCart(item.id)}>
              Supprimer
            </DeliveryOptionButton>
          </CartItem>
        ))}
        {selectedDelivery && (
          <CartItem>
            <CartItemName>Méthode de livraison: {selectedDelivery.name}</CartItemName>
          </CartItem>
        )}
        <form>
          <Info>
            <Input
              type="text"
              placeholder="Le nom de votre société et votre activité"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
            <Input
              type="text"
              placeholder="L'utilisation prévue du sable"
              value={intendedUse}
              onChange={(e) => setIntendedUse(e.target.value)}
            />
            <Input
              type="text"
              placeholder="La destination de la livraison"
              value={deliveryDestination}
              onChange={(e) => setDeliveryDestination(e.target.value)}
            />
          </Info>
        </form>
		<div style={{display: 'flex', gap: '20px', justifyContent: 'center', flexDirection: 'column'}}>
			<SendOrderButton onClick={sendOrderViaWhatsApp}>Passer la commande via WhatsApp</SendOrderButton>
			<GSendOrderButton onClick={sendOrderViaGmail}>Passer la commande via Gmail</GSendOrderButton>
		</div>
      </CartSection>
    </ProductsContainer>
  );
};

export default Products;